import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { RequestApprovalDto } from '../models/requestapproval-dto';
@Injectable({
  providedIn: 'root'
})
export class RequestApprovalsService {


  constructor(private httpClient: HttpClient) { }
  getRequestApprovals(contractId:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
    return this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetByRequestId${contractId}`);
  }

  getByMovementRequestId(contractId:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
;
    var result = this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetByMovementRequestId${contractId}`);
    ;
    return result;
  }
  
  getByManpowerRequestId(contractId:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
    
        var result = this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetByManpowerRequestId${contractId}`);
        ;
        return result;
      }

}
